export default function calendarStyles(theme, ownerState) {
  const {
    breakpoints,
    functions: { pxToRem },
  } = theme;

  return {
    top: pxToRem(-20),
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    gap: pxToRem(18),

    [breakpoints.up("md")]: {
      width: `calc(100% - 80px)`,
    },

    [breakpoints.down("md")]: {
      width: `calc(100% - 40px)`,
    },
  };
}
